module.exports = __webpack_public_path__ + "static/media/soundcloud.577ac521.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/soundcloud.svg
// module id = 226
// module chunks = 0